import React, { useState, useEffect, useContext } from 'react';
import { Grid } from '@material-ui/core';
import { Col, Form, Row, Select, Transfer, Card, Tooltip, Modal } from 'antd';
import Input from '../../ui/Input';
import { SearchOutlined } from '@ant-design/icons';
import { LocalPersistence } from '../../../factories';
import { updateAmenityservice, deleteAmenityservice } from '../../../services/amenityservice';
import { getOTACodes } from '../../../services/common'
import './index.scss'
import Loading from '../../Loading';
import PageContainer from '../../CSIComponents/PageContainer';
import { rightContentWidthContext } from '../../../layouts/RightContentWidthContext'
import ActionButtonsBar from '../../ui/ActionButtonsBar';
import { PROXIMITY_OPTIONS } from '@constants/index'

const validTypes = [
    'Incoming fax complimentary',
    'Outgoing fax complimentary',
    'Fee charged for first page',
    'Fee charged for first page of outgoing fax',
    'Fee per additional page of incoming fax',
    'Fee per additional page of outgoing fax',
]


const { Option } = Select;

const Edit = (props: any) => {

    const [form] = Form.useForm();

    const rightContent: any = useContext(rightContentWidthContext);
    const [transferData, setTransferData] = useState<Array<any>>([])
    const [transferTargetKeys, setTransferTargetKeys] = useState<Array<any>>([props.tableCurrentData.tags && props.tableCurrentData.tags != '' ? props.tableCurrentData.tags.split(" | ") : []])
    const [addLoading, setAddLoading] = useState(false)
    const [data, setData] = useState<Array<any>>([])
    const [typeList, setTypeList] = useState<Array<any>>([]);
    const detailData = props.tableCurrentData;
    const [disabledStatus, setDisabledStatus] = useState(false)
    const [typeValue, setTypeValue] = useState<string>('')
    const [measurementUnits, setMeasurementUnits] = useState<Array<string>>([]);

    const handleCategoryChange = async (e: any, i: any) => {
        form.setFields([{
            name: 'type',
            value: ''
        }])
        let res: any
        let multipleOtaCodes: {}[] = []
        if (e === 'Hotel Amenities') {
            const pr = await Promise.all([
                await getOTACodes('HAC', ''),
                await getOTACodes('RST', ''),
                await getOTACodes('REC', ''),
            ])
            pr.map(({ otacodes }) => {
                multipleOtaCodes = [...multipleOtaCodes, ...otacodes]
                return res = { ...res, otacodes: multipleOtaCodes }
            })
        } else if (e === 'Business Services') {
            res = await getOTACodes('BUS', '')
        } else if (e === 'Meal Plans') {
            res = await getOTACodes('MPT', '')
        } else if (e === 'Meeting Services') {
            res = await getOTACodes('MRC', '')
        }
        // setAddLoading(false)
        if (res && res.otacodes && res.otacodes.length !== 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setTypeList(res.otacodes)
        } else {
            setTypeList([])
        }
    }
    useEffect(() => {
        getTransferData()
        getAvailabilityList()
        getTypeListData()
        if (props.tableCurrentData.type) setTypeValue(props.tableCurrentData.type)
        props.tableCurrentData.tags && props.tableCurrentData.tags !== '' ? setTransferTargetKeys(props.tableCurrentData.tags.split(' | ')) : setTransferTargetKeys([])
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])
    const getTypeListData = async () => {
        let res: any;
        let multipleOtaCodes: {}[] = []
        if (detailData.category === 'Hotel Amenities') {
            const pr = await Promise.all([
                await getOTACodes('HAC', ''),
                await getOTACodes('RST', ''),
                await getOTACodes('REC', ''),
            ])
            pr.map(({ otacodes }) => {
                multipleOtaCodes = [...multipleOtaCodes, ...otacodes]
                return res = { ...res, otacodes: multipleOtaCodes }
            })
        } else if (detailData.category === 'Business Services') {
            res = await getOTACodes('BUS', '')
        } else if (detailData.category === 'Meal Plans') {
            res = await getOTACodes('MPT', '')
        } else if (detailData.category === 'Meeting Services') {
            res = await getOTACodes('MRC', '')
        }
        if (res && res.otacodes && res.otacodes.length != 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setTypeList(res.otacodes)
        } else {
            setTypeList([])
        }
    }
    // get transfer
    const getTransferData = async () => {
        // setAddLoading(true)
        let res = await getOTACodes('TAG', '')
        // setAddLoading(false)
        if (res && res.otacodes && res.otacodes.length != 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setTransferData(res.otacodes)
            setData(res.otacodes)
        } else {
            setTransferData([])
        }
    };

    const getOTA_UOMCodes = async() =>{
        let codeName = []
        const res = await getOTACodes('UOM', 'Distance');
        if (res && res.otacodes && res.otacodes.length != 0) {
            codeName = res.otacodes.map((item: any) =>{
                 return item.codeName;
            })     
            setMeasurementUnits(codeName)
        } else {
            setMeasurementUnits([])
        }
        
    }
    const getAvailabilityList = async () => {
        // setAddLoading(true)
        let res = await getOTACodes('TAG', '')
        // setAddLoading(false)
        if (res && res.otacodes && res.otacodes.length != 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
        } else {
            setTransferData([])
        }
    }
    const onSearchChange = (e: any) => {
        let res = data.filter(item => item.codeName.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1)
        setTransferData(res)
    }
    const handleChange = (targetKeys: any) => {
        setTransferTargetKeys(targetKeys)
    };
    const validateFieldsError = (changedValues: any, allValues: any) => {
        form.validateFields().then(() => {
            setDisabledStatus(false)

        }).catch(() => {
            let savelock = false
            let s = form?.getFieldsError()
            for (let i = 0; i < s.length; i++) {
                if (s[i].errors.length) {
                    savelock = true;
                    break
                }
            }
            setDisabledStatus(savelock)
        })
    }

    useEffect(()=>{
        getOTA_UOMCodes();
    },[])

    const addSave = () => {
        form.validateFields().then(async (value) => {
            const get_session = new LocalPersistence('session')
            const session: any = await get_session.getSessionPersistence()
            value.tags = transferTargetKeys.length != 0 ? transferTargetKeys.join(' | ') : ''
            const params = {
                "supplier": session.supplier,
                "propertyId": session.propertyId,
                "property": {
                    "amenityservice": [
                        {
                            "name": value.name,
                            "category": value.category,
                            "type": value.type,
                            "included": value.included,
                            "proximity": value.proximity,
                            "typedetail": value.typedetail,
                            "avail": value.avail,
                            "id": value.id,
                            "quantity":value.quantity ?  Number(value.quantity): value.quantity,
                            "distance": value.distance ?  Number(value.distance): value.distance,
                            "lanyoncomments": value.lanyoncomments,
                            "tags": value.tags,
                            'amsid': props.tableCurrentData.amsid,
                            'amslangid': props.tableCurrentData.amslangid,
                            'uom': value.uom
                        }
                    ]
                }
            }
            setAddLoading(true)
            const res = await updateAmenityservice(params);
            if (res.result.success) {
                setAddLoading(false)
                props.resetDetailInfo(params.property.amenityservice[0])
                props.handelCancelBtnClick();
            }
        })
    }
    const handlCancelClick = () => {
        props.handelCancelBtnClick();
    }
    const ModalHead = () => {
        return (
            <div style={{
                position: 'absolute',
                left: 0,
                top: 0,
                height: '50px',
                lineHeight: '50px',
                textIndent: '10px',
                borderBottom: '1px solid #ccc',
                color: '#fff',
                background: '#06789D',
                fontSize: 18,
                width: '100%'
            }}>Confirm</div>
        )
    }
    const DeleteClick = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        let bodeData = {
            "supplier": session.supplier,
            "propertyId": session.propertyId,
            "property": {
                "amenityservice": [
                    {
                        "amsid": props.tableCurrentData.amsid,
                        "amslangid": props.tableCurrentData.amslangid,
                    }
                ]
            }
        }
        Modal.confirm({
            title: <ModalHead />,
            centered: true,
            icon: '',
            content: `Are you sure you want to delete this record?`,
            cancelText: 'Cancel',
            okText: 'Delete',
            onOk: async () => {
                setAddLoading(true)
                const res = await deleteAmenityservice(bodeData);
                if (res.result.success) {
                    setAddLoading(false)
                    props.handelCancelBtnClick();
                    props.deleteJupm()
                }
            },
            onCancel() {

            },
        });


    }

    const onChangeType = (type: string) => {
        setTypeValue(type)
        const s = validTypes.find((e: string) => e === type)
        if (!s) {
            form.setFieldsValue({['lanyoncomments']:''})
        }
    }

    const validTypeSelected = () => {
        const s = validTypes.find((e: string) => e === typeValue)
        return s
    }

    if (addLoading) return <Loading type="large" />
    return (
        <PageContainer>
        <Card style={{ marginBottom: '100px' }}>

            <Grid container spacing={0} className="containerSpacing py-0">
                <Grid item xs={12} className="p-0">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        {/* <div style={{ fontWeight: 'bold', fontSize: 14, color: '#333' }}>{detailData.name}</div> */}
                    </div>
                </Grid>
                <Grid item xs={12} className="pb-0 px-0 my-0">
                    <Form
                        layout="vertical"
                        form={form}
                        name="basic"
                        initialValues={detailData}
                        onValuesChange={validateFieldsError}
                    >
                        <Row>
                            <Col span={6}>
                                <Form.Item
                                    label="Name"
                                    name="name"
                                    rules={[{ max: 64, message: 'You have reached the max character length of 64' }]}
                                >
                                    <Input maxLength={64} />
                                </Form.Item>
                            </Col>
                            <Col offset={2} span={6}>
                                <Form.Item
                                    label="Category"
                                    name="category"
                                    rules={[{ required: true, message: 'This field is required' }]}
                                >
                                    <Select allowClear defaultValue="" onChange={(e) => (handleCategoryChange(e, i))}
                                    showSearch>
                                        <Option value="Hotel Amenities">Hotel Amenities </Option>
                                        <Option value="Business Services">Business Services</Option>
                                        <Option value="Meal Plans">Meal Plans</Option>
                                        <Option value="Meeting Services">Meeting Services</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col offset={2} span={6}>
                                <Form.Item name='type' label="Type" rules={[{ required: true, message: 'This field is required' }]}>
                                    <Select allowClear defaultValue=""
                                    onChange = {onChangeType}
                                    showSearch>
                                        {typeList.length > 0 && typeList.map((item: any, index: any) => {
                                            return (
                                                <Option key={index} value={item.codeName}>{item.codeName}</Option>
                                            )
                                        })}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col offset={-2} span={14}>
                                <Form.Item
                                    label="Type Detail"
                                    name="typedetail"
                                    rules={[{ max: 50, message: "You have reached the max character length of 50" }]}
                                >
                                    <Input maxLength={50} />
                                </Form.Item>
                            </Col>
                            <Col offset={2} span={6}>
                                <Form.Item
                                    label="Availability"
                                    name="avail"
                                    rules={[{}]}
                                >
                                    <Select allowClear defaultValue=""
                                    showSearch>
                                        <Option value="Complimentary to All">Complimentary to All</Option>
                                        <Option value="Complimentary to Consortia Only">Complimentary to Consortia Only</Option>
                                        <Option value="Available">Available</Option>
                                        <Option value="Available at a Charge">Available at a Charge</Option>
                                        <Option value="Subject to Availability">Subject to Availability</Option>
                                        <Option value="Not Available">Not Available</Option>
                                        <Option value="Cost not known or varies">Cost not known or varies</Option>
                                        {/* {availabilityList.length > 0 && availabilityList.map((val: any, ind: any) => {
                                        return (
                                            <Option key={ind} value={val.codeName}>{val.codeName}</Option>
                                        )
                                    })} */}

                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Form.Item
                                    label="Service ID"
                                    name="id"
                                    rules={[{ max: 32, message: 'You have reached the max character length of 32' }]}
                                >
                                    <Input maxLength={32} />
                                </Form.Item>
                            </Col>
                            <Col offset={2} span={6}>
                                <Form.Item
                                    label="Quantity"
                                    name="quantity"
                                    rules={[{
                                        required: false,
                                        pattern: new RegExp(/^[0-9]\d*$/, "g"),
                                        message: 'This field should be a number'
                                    }]}
                                >
                                    <Input type="number" />
                                </Form.Item>
                            </Col>
                            <Col offset={2} span={6}>
                                <Form.Item name='included' label="Included in Room Rate" rules={[]}>
                                    <Select allowClear defaultValue=""
                                    showSearch>
                                        <Option value="Yes">Yes</Option>
                                        <Option value="No">No</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Form.Item
                                    label="Proximity"
                                    name="proximity"
                                    rules={[{ required: true, message: 'This field is required' }]}
                                >
                                    <Select allowClear defaultValue="" showSearch>
                                        {Object.values(PROXIMITY_OPTIONS).map(
                                            (item: string, index: number) => (
                                                <Option key={index} value={item}>
                                                    {item}
                                                </Option>
                                            ),
                                        )}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col offset={2} span={6}>
                                <Form.Item
                                    label="Distance"
                                    name="distance"
                                    rules={[{
                                        pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                                        message: 'This field should be a number'
                                    }]}
                                >
                                    <Input type="number" />
                                </Form.Item>
                            </Col>
                        <Col offset={2} span={6}> 
                            <Form.Item
                                label="Measurement Units"
                                name="uom"
                                rules={[{ max: 25, message: 'You have reached the max character length of 25' }]}
                            >
                                <Select allowClear onChange={(e: string) => console.log(e)}
                                    showSearch
                                    value={props.state}
                                >
                                    {
                                        measurementUnits.map((rt: string, index: number) => (
                                        <Option value={rt} key={index}>{rt}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item> 
                        </Col> 
                        <Col span={6}></Col>
                            { validTypeSelected() &&
                                <Col offset={2} span={6}>
                                    <Form.Item
                                        label="Lanyon Comments"
                                        name="lanyoncomments"
                                        rules={[{ max: 25, message: 'You have reached the max character length of 25' }]}
                                    >
                                        <Input maxLength={25} />
                                    </Form.Item>
                                </Col>
                            }

                        </Row>
                        { props.isTagsDisplayed &&
                            <Row>
                                <Col span={16}>
                                    <Form.Item name='tags' label="Selected Tags">
                                        <Input onChange={onSearchChange} style={{ width: '300px' }} suffix={
                                            <Tooltip title="search">
                                                <SearchOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                            </Tooltip>
                                        } />
                                        <Transfer
                                            dataSource={transferData}
                                            targetKeys={transferTargetKeys}
                                            onChange={handleChange}
                                            render={item => item.codeName}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        }

                    </Form>

                </Grid>

            </Grid>
        </Card>
        <ActionButtonsBar
            onDelete={DeleteClick}
            onCancel={handlCancelClick}
            onSave={addSave}
            disabledSave={disabledStatus}
            warningMsg={true}
        />
    </PageContainer>
    );
}
export default Edit;

function i(e: string, i: any): void {
    throw new Error('Function not implemented.');
}
